export  const SAVR_USER_INFO = 'save_user_info'//登录的
export  const DELETE_USER_INFO = 'delete_user_info' //退出登录的